import React from 'react';
import { heroData } from '../data/mock';
import PhoneMockup from './PhoneMockup';
import EmailTrialForm from './EmailTrialForm';
import { Shield, AlertTriangle } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative pt-32 pb-8 md:pt-40 md:pb-24 overflow-hidden">
      <div className="hidden md:block absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] rounded-full bg-blue-600/15 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full bg-blue-500/10 border border-blue-500/25">
            <AlertTriangle className="w-4 h-4 text-blue-300" />
            <span className="text-sm text-blue-100 font-semibold">{heroData.badge}</span>
          </div>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.05] tracking-tight mb-6">
            <span className="text-white">{heroData.headline}</span>
            <br />
            <span className="gradient-text">{heroData.highlight}</span>
          </h1>
          <p className="text-lg md:text-2xl text-white/60 max-w-2xl mx-auto leading-relaxed">
            {heroData.subheadline}
          </p>
        </div>

        <div className="flex flex-col items-center gap-4 mb-12 md:mb-24">
          <div id="trial" className="w-full max-w-md">
            <EmailTrialForm />
          </div>
          <div className="flex items-center gap-2 text-white/40 text-sm">
            <Shield className="w-4 h-4" />
            <span>Sem cartão de crédito · 14 dias grátis</span>
          </div>
        </div>

        {/* Phones — mobile menor, desktop normal */}
        <div className="relative overflow-hidden">
          <div className="flex items-end justify-center gap-2 md:gap-8">
            <div className="transform -rotate-6 -mb-4 opacity-70 scale-[0.55] md:scale-100 origin-bottom">
              <PhoneMockup variant="instagram" />
            </div>
            <div className="transform z-10 scale-[0.7] md:scale-100 origin-bottom">
              <PhoneMockup variant="google" highlighted />
            </div>
            <div className="transform rotate-6 -mb-4 opacity-70 scale-[0.55] md:scale-100 origin-bottom">
              <PhoneMockup variant="facebook" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
